import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ImageCarousel = ({ images }) => {
	const [index, setIndex] = useState(0);
	const [isHovered, setIsHovered] = useState(false);

	useEffect(() => {
		if (isHovered) return;

		const interval = setInterval(() => {
			setIndex((prev) => (prev + 1) % images.length);
		}, 4000);

		return () => clearInterval(interval);
	}, [isHovered, images.length]);

	return (
		<div
			className='relative w-full h-[600px] overflow-hidden bg-black'
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}>
			<AnimatePresence mode='wait'>
				<motion.div
					key={index}
					initial={{ opacity: 0, scale: 1.1 }}
					animate={{ opacity: 1, scale: 1 }}
					exit={{ opacity: 0 }}
					transition={{ duration: 1.2, ease: 'easeInOut' }}
					className='absolute inset-0'>
					<img
						src={images[index]}
						alt='Bioenergy facility'
						className='w-full h-full object-cover opacity-80'
					/>

					<div className='absolute inset-0 bg-gradient-to-r from-black/60 to-transparent' />

					<div className='absolute inset-0 flex flex-col justify-center px-12 text-white'>
						<motion.h2
							initial={{ y: 20, opacity: 0 }}
							animate={{ y: 0, opacity: 1 }}
							transition={{ delay: 0.5 }}
							className='text-5xl font-bold mb-4'>
							Sustainable Power.
						</motion.h2>
						<motion.p
							initial={{ y: 20, opacity: 0 }}
							animate={{ y: 0, opacity: 1 }}
							transition={{ delay: 0.7 }}
							className='text-xl max-w-md text-gray-200'>
							Harnessing organic waste to fuel the next generation
							of clean energy.
						</motion.p>
					</div>
				</motion.div>
			</AnimatePresence>

			<div
				className='absolute bottom-0 left-0 h-1 bg-green-500 z-20 transition-all duration-[5000ms] ease-linear'
				style={{
					width: isHovered ? '0%' : '100%',
					opacity: isHovered ? 0 : 1,
				}}
				key={index}
			/>

			<div className='absolute bottom-8 right-12 flex gap-3 z-30'>
				{images.map((_, i) => (
					<button
						key={i}
						onClick={() => setIndex(i)}
						className={`h-1 transition-all duration-300 ${
							index === i
								? 'w-8 bg-green-500'
								: 'w-4 bg-white/30 hover:bg-white/60'
						}`}
					/>
				))}
			</div>
		</div>
	);
};

export default ImageCarousel;
